// Legacy fallback: non usare per nuovi select, usare /api/zone (useZoneAttive).
// Mantenuto solo per retrocompatibilità su schermate legacy / test offline.
export const ZONES = [
  "CENTRO",
  "FIRENZE NORD",
  "FIRENZE SUD",
  "CAMPI-CALENZANO-SESTO",
  "PRATO",
  "ABETONE",
  "BAGNO A RIPOLI",
];

export const FREQUENZE = ["SETTIMANALE", "BISETTIMANALE", "MENSILE", "BIMESTRALE", "SU_APPUNTAMENTO"];
export const FREQUENZE_LABEL = {
  SETTIMANALE: "Settimanale",
  BISETTIMANALE: "Bisettimanale",
  MENSILE: "Mensile",
  BIMESTRALE: "Bimestrale",
  SU_APPUNTAMENTO: "Su appuntamento",
};

// Blocco A3 — Nuovi campi contratto
export const ALTERNANZE = [
  { v: "DISPARI", label: "Settimane dispari (1ª e 3ª)" },
  { v: "PARI", label: "Settimane pari (2ª e 4ª)" },
];
export const SETTIMANE_MESE = [
  { v: "W1", label: "Prima settimana" },
  { v: "W2", label: "Seconda settimana" },
  { v: "W3", label: "Terza settimana" },
  { v: "W4", label: "Quarta settimana" },
];

// Blocco B6.0 — Mese alternanza per frequenza BIMESTRALE
export const MESI_ALTERNANZA = [
  { v: "PARI", label: "Mesi pari (2, 4, 6, 8, 10, 12)" },
  { v: "DISPARI", label: "Mesi dispari (1, 3, 5, 7, 9, 11)" },
];

// Legacy: mantenuti per Pianificazione.jsx e retrocompat (non toccati in A3)
export const ALTERNANZE_BISETTIMANALI = [
  { v: "PRIMA_TERZA", label: "1° e 3° del mese" },
  { v: "SECONDA_QUARTA", label: "2° e 4° del mese" },
];
export const OCCORRENZE_MENSILI = [
  { v: "PRIMA", label: "1° del mese" },
  { v: "SECONDA", label: "2° del mese" },
  { v: "TERZA", label: "3° del mese" },
  { v: "QUARTA", label: "4° del mese" },
  { v: "ULTIMA", label: "Ultima del mese" },
];

export const GIORNI = ["LUN", "MAR", "MER", "GIO", "VEN"];
export const SETTIMANE = ["W1", "W2", "W3", "W4"];
export const RINNOVI = ["ANNUALE", "BIENNALE", "TRIENNALE", "NESSUNO"];

export const FASCE = ["MATTINA_PRESTO", "MATTINA", "POMERIGGIO", "APPUNTAMENTO"];

// Blocco B4.2 — Fascia oraria di VISITA produttore (distinta da contratto.frequenza).
// NB: ORARIO_SU_APPUNTAMENTO è la fascia (chiamare prima di passare); è cosa diversa
// dalla frequenza SU_APPUNTAMENTO (visite solo on-demand).
export const FASCE_VISITA = [
  { v: "MATTINA_8_12",           label: "Mattina 8-12" },
  { v: "SEMPRE_APERTO",          label: "Sempre aperto" },
  { v: "POMERIGGIO_14_18",       label: "Pomeriggio 14-18" },
  { v: "ORARIO_SU_APPUNTAMENTO", label: "Su appuntamento / da chiamare" },
  { v: "DA_VERIFICARE",          label: "Orario da verificare" },
];
export const FASCE_VISITA_LABEL = {
  SEMPRE_APERTO:          "Sempre aperto",
  MATTINA_8_12:           "8:00–12:00",
  POMERIGGIO_14_18:       "14:00–18:00",
  ORARIO_SU_APPUNTAMENTO: "Su appuntamento",
  DA_VERIFICARE:          "Orario da verificare",
};
export const FASCE_LABEL = {
  MATTINA_PRESTO: "Mattina presto",
  MATTINA: "Mattina",
  POMERIGGIO: "Pomeriggio",
  APPUNTAMENTO: "Su appuntamento",
};
export const FASCE_COLOR = {
  MATTINA_PRESTO: "#1B5E20",
  MATTINA: "#0D9488",
  POMERIGGIO: "#1565C0",
  APPUNTAMENTO: "#F57C00",
};

export function calcSettimanaFromDate(d) {
  const day = d.getDate();
  if (day <= 7) return "W1";
  if (day <= 14) return "W2";
  if (day <= 21) return "W3";
  return "W4";
}

// Bug V6 fix: data rappresentativa nella settimana W (LUN-VEN più vicino),
// preservando il giorno della settimana corrente se possibile.
export function dateForSettimana(currentIsoDate, w) {
  const cur = new Date(currentIsoDate);
  const y = cur.getFullYear();
  const m = cur.getMonth();
  const targetWeekday = cur.getDay(); // 0..6 (DOM..SAB)
  // Day range per W
  const ranges = { W1: [1, 7], W2: [8, 14], W3: [15, 21], W4: [22, 28] };
  const [start, end] = ranges[w] || [1, 7];
  // Cerca giorno nello stesso giorno-settimana entro range, altrimenti primo weekday del range
  for (let d = start; d <= end; d++) {
    const candidate = new Date(y, m, d);
    if (candidate.getDay() === targetWeekday) {
      // Skip if weekend (use first weekday of range)
      if (candidate.getDay() === 0 || candidate.getDay() === 6) break;
      return toIso(candidate);
    }
  }
  // Fallback: primo LUN-VEN nel range
  for (let d = start; d <= end; d++) {
    const candidate = new Date(y, m, d);
    const dw = candidate.getDay();
    if (dw >= 1 && dw <= 5) return toIso(candidate);
  }
  return toIso(new Date(y, m, start));
}

function toIso(d) {
  const y = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${mm}-${dd}`;
}

const ITALIAN_DAY_MAP = ["DOM", "LUN", "MAR", "MER", "GIO", "VEN", "SAB"];

export function calcGiornoFromDate(d) {
  return ITALIAN_DAY_MAP[d.getDay()];
}

export function formatDateIt(isoDate) {
  if (!isoDate) return "-";
  try {
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return isoDate;
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return isoDate;
  }
}

export function daysUntil(isoDate) {
  if (!isoDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(isoDate);
  if (Number.isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function formatCurrency(n) {
  if (n == null) return "€ -";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);
}

export function formatNumber(n) {
  if (n == null) return "-";
  return new Intl.NumberFormat("it-IT").format(n);
}

export function todayIsoDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const STATI_GIRO = ["PIANIFICATO", "IN_CORSO", "COMPLETATO", "ANNULLATO"];

export const STATO_GIRO_LABEL = {
  PIANIFICATO: "Pianificato",
  IN_CORSO: "In corso",
  COMPLETATO: "Completato",
  ANNULLATO: "Annullato",
  INATTIVO: "Inattivo",
};

export const STATO_GIRO_COLOR = {
  PIANIFICATO: "#64748B",
  IN_CORSO: "#F57C00",
  COMPLETATO: "#1B5E20",
  ANNULLATO: "#C62828",
  INATTIVO: "#94A3B8",
};

export const SCADENZA_LIVELLI = ["scaduto", "rossa", "gialla", "ok"];
export const SCADENZA_LABEL = {
  scaduto: "SCADUTO",
  rossa: "URGENTE",
  gialla: "ATTENZIONE",
  ok: "OK",
};
export const SCADENZA_COLOR = {
  scaduto: "#C62828",
  rossa: "#C62828",
  gialla: "#F57C00",
  ok: "#1B5E20",
};

export function classifyScadenza(isoDate, cfg) {
  if (!isoDate) return null;
  const days = daysUntil(isoDate);
  if (days == null) return null;
  if (days < 0) return "scaduto";
  const rosso = cfg?.rossa_giorni ?? 30;
  const giallo = cfg?.gialla_giorni ?? 120;
  if (days <= rosso) return "rossa";
  if (days <= giallo) return "gialla";
  return "ok";
}


// ─── Blocco B5.5: Ritiri da recuperare ───────────────────────────────────
export const MOTIVI_RECUPERO = [
  "TEMPO_INSUFFICIENTE",
  "CLIENTE_CHIUSO",
  "CLIENTE_NON_DISPONIBILE",
  "MEZZO_PIENO",
  "PROBLEMA_TRAFFICO",
  "PROBLEMA_TECNICO",
  "DA_RIPROGRAMMARE",
  "ALTRO",
];

export const MOTIVO_RECUPERO_LABEL = {
  TEMPO_INSUFFICIENTE: "Tempo insufficiente",
  CLIENTE_CHIUSO: "Cliente chiuso",
  CLIENTE_NON_DISPONIBILE: "Cliente non disponibile",
  MEZZO_PIENO: "Mezzo pieno",
  PROBLEMA_TRAFFICO: "Problema traffico",
  PROBLEMA_TECNICO: "Problema tecnico",
  DA_RIPROGRAMMARE: "Da riprogrammare",
  ALTRO: "Altro",
};

export const STATO_RECUPERO_LABEL = {
  APERTO: "Aperto",
  RIPROGRAMMATO: "Riprogrammato",
  RECUPERATO: "Recuperato",
  ANNULLATO: "Annullato",
};

export const STATO_RECUPERO_COLOR = {
  APERTO: "#F57C00",
  RIPROGRAMMATO: "#1565C0",
  RECUPERATO: "#1B5E20",
  ANNULLATO: "#94A3B8",
};
